import React from 'react';

import { IDesignerProfile } from '@components/pages/DesignerProfile/graphql/designer-profile-query.graphql';
import ButtonPrimary from '@components/shared/buttons/ButtonPrimary/ButtonPrimary';
import EditIcon from '@components/shared/images/atoms/EditIcon/EditIcon';

import styles from './PreferButton.module.scss';

interface IPreferButtonProps {
  allowEdit: boolean;
  editing: boolean;
  designer: IDesignerProfile;
  toggleEditing: () => void;
  bookDesigner: () => Promise<void>;
}

const PreferButton = ({
  allowEdit = false,
  designer,
  editing,
  toggleEditing = () => {},
  bookDesigner
}: IPreferButtonProps) => {
  const { firstName } = designer;

  return (
    <div className={ styles.Wrapper }>
      <ButtonPrimary
        className={ styles.PrimaryButton }
        disabled={ false }
        onClick={ allowEdit ? toggleEditing : bookDesigner }
      >
        {
          allowEdit && (
            editing ? 'Done' : (
              <>
                <i className={ styles.EditIcon }>
                  <EditIcon />
                </i>
                Edit profile
              </>
            )
          )
        }

        {
          !allowEdit && (`Design your space with ${firstName}`)
        }
      </ButtonPrimary>
    </div>
  );
};

export default PreferButton;
